var map = {
	"./Confirm-password.svg": 3671,
	"./Courses.svg": 75337,
	"./Duration.svg": 19577,
	"./addvideodownload.svg": 42423,
	"./adminicon.svg": 90505,
	"./announcementicon.svg": 96295,
	"./arvrstudioicon.svg": 77449,
	"./assessmentcompleted.svg": 5694,
	"./assessmenticon.svg": 49440,
	"./birthday.svg": 62378,
	"./calendar.svg": 90023,
	"./calendaricon.svg": 77896,
	"./classroom.svg": 45338,
	"./classroomicon.svg": 25337,
	"./competencyicon.svg": 82825,
	"./confirm-email.svg": 96612,
	"./courseicon.svg": 11461,
	"./cpdicon.svg": 68899,
	"./customer-support.svg": 99099,
	"./dashboardicon.svg": 46308,
	"./deleteicon.svg": 77703,
	"./dglib.svg": 74731,
	"./digital-library-icon.svg": 61605,
	"./discussionsicon.svg": 67675,
	"./download.svg": 99593,
	"./editicon.svg": 23534,
	"./education.svg": 76181,
	"./email.svg": 38343,
	"./embedded_link.svg": 92866,
	"./experience.svg": 26613,
	"./file-upload.svg": 8143,
	"./firstname.svg": 28051,
	"./icon_white/announcementicon.svg": 63833,
	"./icon_white/announcementicon1.svg": 90266,
	"./icon_white/assessmenticon.svg": 95350,
	"./icon_white/calendaricon.svg": 59006,
	"./icon_white/classroom.svg": 87764,
	"./icon_white/classroomicon.svg": 59087,
	"./icon_white/competencyicon.svg": 95467,
	"./icon_white/courseicon.svg": 78239,
	"./icon_white/cpdicon.svg": 9413,
	"./icon_white/dashboardicon.svg": 97818,
	"./icon_white/discussionsicon.svg": 32413,
	"./icon_white/discussionsicon1.svg": 95766,
	"./icon_white/learningpathicon.svg": 17387,
	"./icon_white/mobileicon.svg": 75318,
	"./icon_white/onboarding.svg": 10668,
	"./icon_white/organizationicon.svg": 92601,
	"./icon_white/plagiarismicon.svg": 52897,
	"./icon_white/reportsicon.svg": 5847,
	"./icon_white/settingicon.svg": 38250,
	"./icon_white/skills.svg": 98241,
	"./icon_white/socialwall.svg": 26146,
	"./icon_white/socialwallicon.svg": 69425,
	"./icon_white/video-conferencing.svg": 72510,
	"./icon_white/videoconferencingicon.svg": 99404,
	"./lastname.svg": 26588,
	"./leaderboard.svg": 64950,
	"./learningpathicon.svg": 63321,
	"./logo_001.svg": 52236,
	"./logo_002.svg": 31263,
	"./logo_003.svg": 93326,
	"./messagesicon.svg": 4306,
	"./mobile.svg": 86379,
	"./mobileicon.svg": 7932,
	"./onboarding.svg": 38242,
	"./organization.svg": 37408,
	"./organizationicon.svg": 27899,
	"./password.svg": 81925,
	"./plagiarismicon.svg": 56747,
	"./poweredBy.svg": 65136,
	"./proctor_calendar.svg": 87357,
	"./reportsicon.svg": 41921,
	"./settingicon.svg": 13504,
	"./skills.svg": 5375,
	"./socialwallicon.svg": 98359,
	"./status.svg": 18051,
	"./themeicon.svg": 5867,
	"./toolspluginsicon.svg": 82313,
	"./totalassessment.svg": 24407,
	"./upcomingassessment.svg": 43261,
	"./uploadIcon.svg": 285,
	"./user-_1_.svg": 69968,
	"./user-badge.svg": 30494,
	"./username.svg": 72757,
	"./usersicon.svg": 49128,
	"./vdouploder.svg": 87347,
	"./video-conferencing.svg": 27308,
	"./videoconferencingicon.svg": 3250
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46567;